import { render, staticRenderFns } from "./ProjectsShowPage.vue?vue&type=template&id=7af799a0&scoped=true&"
import script from "./ProjectsShowPage.vue?vue&type=script&lang=js&"
export * from "./ProjectsShowPage.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsShowPage.vue?vue&type=style&index=0&id=7af799a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af799a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7af799a0')) {
      api.createRecord('7af799a0', component.options)
    } else {
      api.reload('7af799a0', component.options)
    }
    module.hot.accept("./ProjectsShowPage.vue?vue&type=template&id=7af799a0&scoped=true&", function () {
      api.rerender('7af799a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/projects/ProjectsShowPage.vue"
export default component.exports